export default "__VITE_ASSET__zbhY7g0M__"